<template>
    <div class="fullprog">

        <div class="fullprog" v-if="clientProg">
            <Nav v-if="this.$route.name == 'client'" />
            <div class="profile_client_page">

                <div class="peofile_account">
                    <div class="dot_profile_page"></div>
                    <div class="dot_profile_page1"></div>
                    <div class="profile_picture">
                        <span>{{ clientProg.nom[0] }} {{ clientProg.prenom[0] }}</span>
                    </div>
                    <div class="profile_infos">
                        <span class="profile_name">{{ clientProg.nom }} {{ clientProg.prenom }}</span>
                        <span class="profile_email">{{ clientProg.email }}</span>
                    </div>
                    <div class="profile_action">
                        <i class="fa-regular fa-user-pen i-r w" @click="$bvModal.show('bv-modal-update')"></i>
                    </div>

                </div>
                <div class="profile_points">
                    <div class="profile_point">
                        <div class="dot_profile_page2"></div>
                        <div class="dot_profile_page4"></div>
                        <i class="fa-solid fa-face-tongue-money fa-2x"></i>
                        <span>{{ calculCredit() }}</span>
                    </div>
                    <div class="profile_point1">
                        <i class="fa-solid fa-star fa-2x"></i>
                        <span>{{ calculEarn() }}</span>
                    </div>

                </div>



                <div class="profile_orders_title">
                    <span>Vos dernières commandes <div class="dot_profile_page3"></div></span>

                    <div class="profile_orders_title_button" @click="$modal.hide('profile'), $modal.show('historique')">
                        Toutes
                    </div>
                </div>


                <div class="profile_orders">
                    <div class="profile_order" v-for="comnd in lastthree" :key="comnd._id">
                        <div v-if="comnd.commande" class="profile_order_menu">
                            <span>{{ comnd.commande.menu }}</span>
                        </div>
                        <div v-if="comnd.commande" class="profile_order_infos">
                            <span>{{ comnd.commande.menu_items.length }} Articles</span>
                            <div></div>
                            <span v-if="comnd.total">{{ comnd.total }} {{ comnd.commande.currency_code }}</span>
                            <span v-else-if="comnd.commande.Due._text">{{ comnd.commande.Due._text }} {{ comnd.commande.currency_code }}</span>
                            <div></div>
                            <span>{{ extractDate(comnd.commande.date) }}</span>
                        </div>

                        <div v-if="comnd.commande" class="profile_order_state">
                            <div class="profile_order_ref">
                                <span>REF : {{ lastfour(comnd.commande.ref) }}</span>
                            </div>
                            <div class="profile_order_ref1" @click="showModal('modalcmd', comnd)">
                                <span>Details</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!--MODIFICATION DU PROFIL-->

            <b-modal id="bv-modal-update" name="bv-modal-update" class="profile_update" hide-footer hide-header>
                <div style="padding:16px; cursor:pointer;" @click="$bvModal.hide('bv-modal-update')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                </div>
                <div class="profile_header">
                    <div class="profile_title">Modifier</div>
                    <div class="profile_title1">Profil<span class="profile_button_circle"></span></div>
                    <div class="profile_circle"></div>
                    <div class="profile_circle1"></div>
                    <div class="profile_circle2"></div>
                </div>
                <div class="profile_form">
                    <form>
                        <!--<div class="label_circle"></div>-->
                        <label class="profile_label" for="">Nom <span class="profile_button_circle_green"></span></label>
                        <input class="profile_input" type="text" v-model="formedit.nom">
                        <label class="profile_label" for="">Prenom <span class="profile_button_circle_green"></span></label>
                        <input class="profile_input" type="text" v-model="formedit.prenom">
                        <label class="profile_label" for="">Email <span class="profile_button_circle_green"></span></label>
                        <input class="profile_input" type="email" v-model="formedit.email">
                        <label class="profile_label" for="">Adresse <span
                                class="profile_button_circle_green"></span></label>
                        <input class="profile_input" type="text" v-model="formedit.adresse">
                        <label class="profile_label" for="">Téléphone <span
                                class="profile_button_circle_green"></span></label>
                        <input class="profile_input" type="text" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                            v-model="formedit.telephone">
                    </form>
                    <b-button class="mt-3 submitedit" block
                        @click="submitForm('bv-modal-update'); $bvModal.hide('bv-modal-update')">Submit
                        <span class="profile_button_circle"></span>
                    </b-button>
                </div>

            </b-modal>


            <b-modal id="modalcmd" ref="modalcmd" hide-footer hide-header>
                <div style="padding:16px; cursor:pointer;" @click="$bvModal.hide('modalcmd')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                </div>
                <div v-if="commande" class="cmddetails">
                    <div class="dot_commande_page"></div>
                    <div class="dot_commande_page1"></div>
                    <div class="dot_commande_page2"></div>
                    <div class="dot_commande_page3"></div>
                    <div class="dot_commande_page4"></div>
                    <div class="refdate">
                        <span class="cmdreference">{{ commande.commande.ref }}</span>
                        <span class="cmddate">{{ extractDate(commande.commande.date) }} </span>
                    </div>
                    <table class="table">
                        <tr>
                            <th scope="col">Articles</th>
                            <th scope="col">Quantité</th>
                            <th scope="col">Prix</th>
                        </tr>

                        <tr v-for="item in commande.commande.menu_items" :key="item._id">

                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                {{ item.quantity }}
                            </td>
                            <td>{{ item.quantity * item.price }} {{ commande.commande.currency_code }}</td>

                        </tr>
                        <tr>
                            <td colspan="2">Total:</td>
                            <td>{{ commande.total }} {{ commande.commande.currency_code }}</td>
                        </tr>
                        <tr v-if="commande.points > 0">
                            <td colspan="2">Vous avez gagné:</td>
                            <td>{{ commande.points }} Points</td>
                        </tr>
                        <tr v-if="commande.points < 0">
                            <td colspan="2">Vous avez consommé:</td>
                            <td>{{ commande.points }} Points</td>
                        </tr>
                    </table>
                </div>
                <div class="download" @click="startDownload">
                    <button class="download_button">Télécharger</button>
                </div>
            </b-modal>

        </div>

        <div v-else>
            <div class="center_all">
                <span>
                    Connectez-vous pour voir votre profil
                    <button class="login_button" @click="$modal.hide('profile'), $modal.show('login')">Login</button>
                </span>
            </div>
            <!--<div id="client_save" v-if="(login == 0)" @click="login = 1" class="modal_button">
                <div class="modal_button_text">Login</div>
            </div>
            <div v-if="login = 1">

                <Bienvenue />
                <Login ref="loginForm" :CheckOrder="checkOrder" />

                <div id="client_save" @click="SignIn(),login=2" v-if="login == 1" class="modal_button">
                    <div class="modal_button_text">Login</div>
                </div>
            </div>
        -->
        </div>
    </div>
</template>
<script>
import Nav from './Nav.vue'

import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment"
import { MonthPickerInput } from 'vue-month-picker'

import Login from '../authentification/Login.vue'
import Orangedot from '../designs/Orangedot.vue';
import Bienvenue from '../designs/Bienvenue.vue';

import { computed } from "vue";


export default {

    data() {

        var datefilter = new Date()
        return {
            isLoad: false,
            datefilter: datefilter,

            commande: "",

            min: null,
            max: null,
            date: {
                from: null,
                to: null,
                month: null,
                year: null
            },

            login: 0,

            formedit: {
                nom: "",
                prenom: "",
                email: "",
                adresse: "",
                telephone: "",
            },
        }
    },
    components: {
        Nav,
        MonthPickerInput,
        Login,
        Orangedot,
        Bienvenue,
    },

    computed: {
        ...mapGetters(["clientProg", "cltprg", "lastthree"])
    },
    methods:
    {

        ...mapActions(["getClientProg", "editClient", "getlastthree", "downloadFile"]),
        ...mapMutations(["getClientSuccess", "getLatestSuccess"]),
        startDownload() {
            this.downloadFile(this.commande.commande);
        },
        SignIn() {
            let email = this.$refs.loginForm.email;
            let password = this.$refs.loginForm.password;

            const form = {
                email: email,
                password: password,
            };
            this.loginProg(form).then((res) => {
                if (res.ok) {
                    // window.location.href = '/'
                    // this.$router.push('/client')
                    this.getClientProg()
                    console.log(res.client)
                    // this.addClientSuccess(res.client)
                    // this.saveClient();
                    // this.CheckOrder();
                }
                // this.$router.push('Login')
            })
        },
        lastfour(checknum) {
            var lastfour = checknum.substr(checknum.length - 4);
            return lastfour;
        },
        convertdate() {
            // const now = new Date()
            // let datefilter = this.datefilter
            //const today = new Date(datefilter.getMonth(), datefilter.getDate())
            //this.datefilter= today
            let maxdate = moment(this.datefilter).endOf('month').format()
            maxdate = moment(maxdate, moment.ISO_8601)
            let mindate = moment(this.datefilter).startOf('month').format()
            mindate = moment(mindate, moment.ISO_8601)
            // let mindate=moment(this.datefilter).startOf('month').format("YYYY-MM-DD")
            let payload = {
                maxdate: maxdate,
                mindate: mindate,

            }

            return payload

        },
        calculEarn() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                ttl = ttl + this.cltprg[i].points
            }
            if (ttl >= 0) {
                return ttl.toFixed(2)
            }
            else {
                ttl = 0
                return ttl
            }
        },
        calculCredit() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                if (this.cltprg[i].total) {
                    ttl = ttl + this.cltprg[i].total
                }
            } return ttl.toFixed(2)
        },
        gotoCmd() {
            setTimeout(() => {
                this.$router.push({ name: 'Historique' })
            }, 200)
        },
        logout() {
            localStorage.setItem("accessToken", "")
            setTimeout(() => {
                this.$router.push({ name: 'Login' })
            }, 200)
        },
        responav() {
            var x = document.getElementById("myTopnav");
            if (x.className === "topnav") {
                x.className += " responsive";
            } else {
                x.className = "topnav";
            }
        },
        showModal(refname, cmd) {
            this.commande = cmd;

            this.$refs[refname].show();
        },
        hideModal(refname) {
            this.$refs[refname].hide();
        },
        firstletter() {
            let nom = Array.from(this.clientProg.nom)[0].toUpperCase();
            let prenom = Array.from(this.clientProg.prenom)[0].toUpperCase();
            let nomcom = nom.concat(' ', prenom)
            return nomcom
        },
        generateReport(cmd) {
            // this.changecmd(cmd).then(() => {
            // this.$refs.html2Pdf.generatePdf()
            // })
            this.commande = cmd;
            console.log("VOICI LA COMMANDE" + this.commande.commande.CheckNum)
            this.$refs.html2Pdf.generatePdf()

        },

        extractDate(date) {
            let datec = moment(date).format("YYYY-MM-DD")
            return datec;
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(800)
                    pdf.setTextColor(150)
                    pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                }
            })
            //.save()
        },

        submitForm(refname) {
            const form = {
                // id: this.$route.params.id,
                nom: this.formedit.nom,
                prenom: this.formedit.prenom,
                email: this.formedit.email,
                adresse: this.formedit.adresse,
                telephone: this.formedit.telephone,
            };
            this.editClient({ form }).then((res1) => {
                this.getClientProg().then((res) => {
                    if (res.ok) {
                        this.formedit = {
                            nom: this.clientProg.nom,
                            prenom: this.clientProg.prenom,
                            email: this.clientProg.email,
                            adresse: this.clientProg.adresse,
                            telephone: this.clientProg.telephone,
                        }
                        this.$notify({
                            group: "edit-success",
                            type: "success",
                            title: "Réussi",
                            text:
                                "Vous avez modifié votre profil avec succes "
                        });
                        // this.$emit('show-connected', this.clientProg.nom);
                    }
                });
            });


            // const promise1 = new Promise((resolve, reject) => {
            //     resolve();
            // });

            // promise1.then((value) => {
            //     
            // });
            // .then((res) => {
            //     if (res.ok) {
            //         // this.$router.push({
            //         //     name: "fidelite_list_1",
            //         //     params: { restaurant: this.$route.params.restaurant }
            //         // });
            //         //window.location.reload()
            //         // $bvModal.hide('bv-modal-update')
            //     }
            //     else {
            //         console.log("NOT EDITED")
            //     }
            // })

        },

        notify() {
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: 'Hello ' + this.formedit.nom + ' ' + this.formedit.prenom + '! This is a notification!'
            });
        }

    },
    mounted() {
        // if(!localStorage.getItem("accessToken")){
        //     this.$router.push({ name: 'Login' })
        // }

        this.getClientProg();
        this.getlastthree().then((res) => {
            // if (res.err) {
            //     this.$router.push({ name: 'Login' })

            // } else {
            this.isLoad = true;
            this.formedit = {
                nom: this.clientProg.nom,
                prenom: this.clientProg.prenom,
                email: this.clientProg.email,
                adresse: this.clientProg.adresse,
                telephone: this.clientProg.telephone,
                //     }

            }
        });
    }
}
</script>
<style scoped>
body {
    background: linear-gradient(160deg, #1e3a34, #264740);
}

.center_all {
    background: linear-gradient(160deg, #1e3a34, #264740);

    display: flex;
    width: 100%;
    height: 60vh;
    justify-content: center;
    align-content: center;
    padding-top: 30vh;

}

.center_all span {
    height: fit-content;
    display: inline-block;
    flex: unset !important;
}

.login_button {

    background: #f05d2e;
    color: #fff;
    /* padding: 12px; */
    text-align: center;
    display: flex;
    justify-content: center;
    /* margin: 0px 6px; */
    align-items: center;
    padding: 12px;
    font-size: 12px;
    border-radius: 151px;
}

.fullprog {
    width: 100%;
    box-sizing: border-box;
    background: linear-gradient(160deg, #1e3a34, #264740);
    /* background-color: #f6f3f1; */
}

/* 
.menu_prog div {
    width: 30px;
    height: 3px;
    background: black;
    border-radius: 5px;
    margin: 3px;
}

.pdf {
    width: 100%;
    font-size: 22px;
    margin: 0 20px;
}

.pdf .header_commande {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px 0 60px 30px;
}

.pdf .header_commande .logo_commande {
    width: 50%;
    display: flex;
    align-self: flex-start;
    
}

.pdf .header_commande .resto_commande {
    width: 50%;
    display: flex;
    align-self: flex-end;
    text-transform: uppercase
     
}

.pdf .header_commande .logo_prog {
    width: 160px;
}

.pdf .client_info {
    margin-left: 30px;
    display: flex;
    flex-direction: column;
} */


.prog_body {
    margin-top: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.profil_clt {
    height: auto;
    background: linear-gradient(160deg, #1e3a34, #264740);
    margin: 20px auto;
    display: flex;
    flex-direction: row;
    padding: 30px;
    width: calc(100% - 48px);
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}

.n-abbr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.name_abbr {

    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    background: linear-gradient(160deg, #1e3a34, #264740);
    height: 100px;
    border-radius: 50%;
}

.infos_profil {
    color: #fff;
    margin: 0 50px;
    text-align: start;
}

.info {
    margin: 10px 0;
}

.title_pts {
    color: #f05d2e;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    /* padding: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border: 1px solid #f05d2e;

}

.prog_points {
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px auto;

}

.prog_point {
    padding: 12px;
    background: #f05d2e;
    width: 48%;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 5px;
}


.title_cmd {
    color: #1e3a34;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    /* padding: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border: 1px solid #264740;
}

.filterbydate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 80%;
}

.filterbydate .date {
    width: 35%;
}

.latest_cmd {
    margin: 20px auto;
    display: flex;
    flex-direction: column;

    width: calc(100% - 48px);
    justify-content: center;
    align-items: center;
    border: 1px solid #264740;
    border-radius: 5px;
}

.latest_cmd a {
    cursor: pointer;
}

.plus {
    display: flex;
    align-self: flex-end;
    font-size: medium;
    cursor: pointer;
}

.plus .a {
    color: #f05d2e;
    display: flex;
    margin-right: 30px;
    margin-bottom: 10px;

}

.plus .a .circle {
    color: #fff;
    background-color: #f05d2e;
    /* border : 1px solid #f05d2e; */
    width: 20px;
    height: 20px;
    margin-top: 2px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;

}

.dtls_cmd_dsng {
    width: 85%;
    height: 100%;
    border-radius: 6px;
    margin: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dtls_cmd_dsng .containercmd {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.bande_header {
    color: #666B7D;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 20px 20px;

}

.dtls_cmd_dsng .cmddtl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1e3a34;
    padding: 10px 5px;
    margin: 30px 2%;
    border-bottom: 1px solid #fff;
    background-color: #fff;
    border-radius: 30px;
    cursor: pointer;
    width: 50%;
}

.dtls_cmd_dsng .cmddtl .ch_n {
    display: flex;
    background-color: #f05d2e;
    padding: 3%;
    border-radius: 20px;
    color: #f6f3f1;
}

.menu-wrap {
    background-color: #fff;
    /* margin-bottom: 30px; */
    width: 100%;
    border-radius: 10px;
}

.dtls_cmd_dsng .containercmd {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}


.commandes {
    display: flex;
    justify-content: space-around;
    align-items: center;
    /* padding-bottom: 15px;
    margin-bottom: 15px; */
    border-bottom: 1px dashed #ccc;
    padding: 15px;
    width: 100%;
}

.commandes p {
    margin-bottom: 0;
    display: flex;
    padding: 0 15%;
}

.commandes .text-wrap {
    width: calc(100% - 95px);
    margin-left: 15px;
    color: #666B7D;
}

.commandes .text-wrap h4 {
    font-size: 20px;
    font-weight: 300;
}

.commandes .text-wrap h6 {
    font-weight: 300;
}

.menu-price {
    text-align: right;
}

.commandes .order_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
}

.order_status {
    display: flex;
    /* justify-content: space-around; */
    justify-content: flex-start;
    align-items: center;
}

.order_status h4,
.order_status h6 {
    width: 40%;
    background: linear-gradient(160deg, #1e3a34, #264740);
    color: #fff;
    border-radius: 15px;
    margin: 0 15px 0 0;
}

.article_list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 60%;
}

.order_restau {
    display: flex;
    justify-content: flex-start;
}

.cmd_details {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* margin: 20% 0; */

}

.commande-ligne {
    display: flex;
    justify-content: space-between;
    /* align-items: flex-start; */
    width: 100%;
}


#modalcmd {
    background: linear-gradient(160deg, #1e3a34, #264740);
}


.profile_client_page {
    width: 100%;
    padding: 24px 12px;
    padding-top: 52px;
    margin-bottom: 120px;
}

.peofile_account {
    background: #fff;
    padding: 24px 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 5px;
    color: #1e3a34;
    position: relative;
}

.profile_picture {
    background: #f05d2e;
    width: 65px;
    height: 65px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.profile_picture span {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}

.profile_infos {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: 12px;
}

.profile_name {
    font-size: 20px;
    font-weight: bold;
    margin: 0px;
}

.profile_email {
    font-size: 14px;
    margin: 0px;
}

.profile_action {
    display: flex;
    justify-content: center;
    align-items: center;
}

.profile_points {
    padding-top: 36px;
    display: flex;

}

.profile_point {
    flex: 1;
    position: relative;
    margin-right: 12px;
    padding: 24px;
    background: #fff;
    color: #f05d2e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    font-weight: 600;
}

.profile_point1 {
    flex: 1;
    padding: 24px;
    background: #fff;
    color: #f05d2e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    font-weight: 600;
}

.profile_point i,
.profile_point1 i {
    color: #f05d2e;
}


.profile_orders {
    display: flex;
    flex-direction: column;
    margin-top: 18px;
}

.profile_order {
    background-color: #fff;
    color: #1e3a34;
    padding: 12px;
    margin: 3px 0px;
    border-radius: 5px;
}

.profile_order_menu {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 6px;

}

.profile_order_infos {
    width: 100%;
    display: flex;
    align-items: center;
}

.profile_order_infos span {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
}

.profile_order_infos div {
    width: 6px;
    height: 6px;
    background: #f05d2e;
    border-radius: 50%;

}

.profile_order_state {
    display: flex;
    justify-content: space-between;
}

.profile_order_ref {
    background: linear-gradient(160deg, #1e3a34, #264740);
    color: #fff;
    border-radius: 5px;
    padding: 3px 12px;
    font-size: 14px;
    margin-top: 6px;
}

.profile_order_ref1 {
    background: #f05d2e;
    color: #fff;
    border-radius: 5px;
    padding: 3px 12px;
    font-size: 14px;
    margin-top: 6px;
}

.profile_orders_title {
    display: flex;
    justify-content: space-between;
    background: transparent;
    color: #f05d2e;
    align-items: center;
    position: relative;
    border-radius: 5px;
    margin-top: 36px;
}

.profile_orders_title span {
    flex: 1;
    padding: 12px;
    color: #fff;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
}

.profile_orders_title_button {
    padding: 12px;
    background: #fff;
    color: #1e3a34;
    border-radius: 5px;
    text-decoration: underline;
}

.dot_profile_page {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: -10%;
    right: 10%;
}

.dot_profile_page1 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 90%;
    left: 20%;
}

.dot_profile_page2 {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 75%;
    left: 80%;
}

.dot_profile_page4 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: -10%;
    left: 120%;
}

.dot_profile_page3 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f05d2e;
    display: inline-block;
}

.i-r {
    float: right;
    margin-right: 16px;
    margin-top: 16px;
    cursor: pointer;
}

.w {
    color: #1e3a34;

}

.cmddetails {
    margin-top: 50px;
}

.cmddetails table {
    width: 100%;
    font-size: 30px;
    margin: 50px 0;
}

.table td,
.table th {
    font-size: 14px;
    width: 25%;
    /* text-align: center; */
}

.refdate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    margin: 20px 0;
}

.refdate .cmdreference {
    border: 1px solid #264740;
    border-radius: 5px;
    padding: 20px;
    transform: rotate(-10deg);
}

.refdate .cmddate {
    background: linear-gradient(160deg, #1e3a34, #264740);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
}

.download {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.download .download_button {
    width: 35%;
    font-size: 14px;
    background-color: #f05d2e;
    color: #fff;
}


.dot_commande_page {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 35%;
    left: 10%;
}

.dot_commande_page1 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 10%;
    left: 52%;
}

.dot_commande_page2 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 25%;
    right: 20%;
}

.dot_commande_page3 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 70%;
    right: 10%;
}

.dot_commande_page4 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 57%;
    right: 50%;
}

.profile_header {
    color: #fff;
    display: flex;
    flex-direction: column;
    flex: 2;
    justify-content: center;
    align-items: flex-start;
    padding: 0 0 0 24px;
    position: relative;
}

.profile_title {
    font-size: 62px;
    font-weight: bold;

}

.profile_title1 {
    font-size: 62px;
    font-weight: bold;
    transform: rotate(5deg);
    position: relative;
    bottom: 20px;
}

.profile_circle {
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    background: #f05d2e;
    border-radius: 50%;
    top: 26%;
    left: 13px;
}

.profile_circle1 {
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    background: #f05d2e;
    border-radius: 50%;
    top: 41%;
    left: 150px;
}

.profile_circle2 {
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    background: #f05d2e;
    border-radius: 50%;
    top: 62%;
    left: 19%;

}

.profile_form {
    flex: 2;
    display: flex;
    flex-direction: column;
    padding: 0px 24px;
}

.profile_label {
    padding: 2px 15px;
    background-color: #f05d2e;
    border-radius: 40px;
    margin: 12px 0 10px 5px;
    /* font-size: 18px !important; */
    text-align: left;
    text-transform: uppercase;
    color: #fff;
    font-weight: bold;
}

.profile_input {
    padding: 24px;
    background-color: #fff;
    border-radius: 40px;
    margin-bottom: 12px;
    font-size: 16px !important;
    text-align: left;
    color: #1e3a34;
}

.submitedit {
    background-color: #f05d2e;
    border-radius: 40px !important;
    border: 0;
    text-transform: capitalize;
    background-color: #fff;
    margin-bottom: 12px;
    font-size: 18px !important;
    text-align: center;
    color: #1e3a34;
    padding: 12px;
}


.profile_button_circle {
    width: 8px;
    height: 8px;
    background: #f05d2e;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 6px;
}

.profile_button_circle_green {
    width: 8px;
    height: 8px;
    background: linear-gradient(160deg, #1e3a34, #264740);
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 6px;
}

.label_circle {
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    background: linear-gradient(160deg, #1e3a34, #264740);
    border-radius: 50%;
    top: 28%;
    left: 30%;
}

@media screen and (max-width: 600px) {

    /* .prog_body {
    margin-top: 10%;
} */

    .grid-7 {
        margin-top: 0;
    }

    .dtls_cmd_dsng {
        width: 95%;
    }

    .dtls_cmd_dsng .cmddtl {
        width: 100%;
    }

    .cmd_details {
        margin: 10% 0;
    }

    .menu-wrap {
        width: 100%;
    }

    .commandes {
        padding: 15px 0;

    }

    .commandes p {
        padding: 0 10%;
    }

    .commandes .text-wrap h4 {
        font-size: 18px;
    }

    .prog_body {
        margin-top: 10%;
    }
}
</style>
